const checkNullData = (data: any) => {
  if (data || data === false) {
    return data;
  }
  return '';
};
export default checkNullData;
